<template>
    <div class="mainContent">
    <table class="table table-sm table-striped table-bordered table-hover">
        <tbody><tr>
            <th><i>{{gene}}(RNAi)</i> phenotype</th>
            <th rowspan="2">
                <tabs>
                    <tab :name="'Reciprocal matches for <i> ' + gene + '(RNAi)</i>'" selected="true">
                        <video controls loop autoplay>
                            <source :src="getReciprocalHitsMovie(itemId)" type="video/mp4">
                            Sorry, your browser doesn't support embedded videos.
                        </video>
                    </tab>
                    <tab :name="'Top phenotypic matches for <i> ' + gene + '(RNAi)</i>'">
                        <video controls loop autoplay>
                            <source :src="getTophitsMovie(itemId)" type="video/mp4">
                            Sorry, your browser doesn't support embedded videos.
                        </video>
                    </tab>
                </tabs>
            </th>
        </tr>
        <tr>
            <td style="padding-top: 2.5rem">
                <video controls loop autoplay height="500">
                    <source :src="getCompMovie(itemId)" type="video/mp4">
                    Sorry, your browser doesn't support embedded videos.
                </video>
            </td>
        </tr>
        </tbody>
    </table>
    </div>
</template>

<script>
  import Tabs from '@/components/Tabs.vue';
  import Tab from '@/components/Tab.vue';

  export default {
    name: "MovieView.vue",
    components: {
      Tabs, Tab
    },
    data() {
      return {
        gene: this.$route.params.gene,
        itemId: this.$route.params.id,
        publicPath: process.env.BASE_URL
      }
    },
    methods: {
      zeroPad(num, places) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
      },
      getCompMovie(num) {
        const vm = this
        let id = vm.zeroPad(num, 4)
        return `/mov/EMBD${id}_Comp.mp4`
      },
      getTophitsMovie(num) {
        const vm = this
        let id = vm.zeroPad(num, 4)
        return `/mov/EMBD${id}_tophits.mp4`
      },
      getReciprocalHitsMovie(num) {
        const vm = this
        let id = vm.zeroPad(num, 4)
        return `/mov/EMBD${id}_reciprocal_hits.mp4`
      }
    },
    mounted() {
      // const vm = this
      // /* eslint-disable no-console */
      // console.log(vm.itemId);
    },
  }
</script>

<style>
    @import url('~@/assets/bootstrap.css');
    @import url('~@/assets/datatable.css');

    .tabs {
        margin-bottom: 0px;
    }
    .mainContent {
        border-radius: 25px;
        border: 2px solid #dae3f3;
        padding: 20px;
        margin: 1.5rem;
    }
</style>